var render, staticRenderFns
import script from "./switch-device.vue?vue&type=script&lang=js&"
export * from "./switch-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('814b679a')) {
      api.createRecord('814b679a', component.options)
    } else {
      api.reload('814b679a', component.options)
    }
    
  }
}
component.options.__file = "src/components/global/switch-device.vue"
export default component.exports